/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Coriunder
 */
export class Coriunder {
    /**
     *
     * @type {string}
     * @memberof Coriunder
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Coriunder
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Coriunder
     */
    type: CoriunderTypeEnum;
    /**
     *
     * @type {string}
     * @memberof Coriunder
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Coriunder
     */
    merchantID: string;
    /**
     *
     * @type {string}
     * @memberof Coriunder
     */
    hostURL?: string;
    /**
     *
     * @type {boolean}
     * @memberof Coriunder
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Coriunder
     */
    autoApprove: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum CoriunderTypeEnum {
    Payotop = 'payotop',
    Gatewayhub = 'gatewayhub',
    Gr8pay = 'gr8pay',
    CoriunderDynamic = 'coriunderDynamic',
}
